// Unpublished Work © 2022 Deere & Company

import t from 'tcomb';
import {CustomerType, customerTypes} from '../../enum/customer-type';

export const TaxId = t.struct({
    countryCode: t.String,
    taxIdDesc: t.String,
    taxIdType: t.String,
    hardRequired: t.Boolean,
    display: t.Boolean,
    customerType: CustomerType,
    taxIdTypeId: t.Number
}, {
    defaultProps: {
        countryCode: '',
        taxIdDesc: '',
        taxIdType: '',
        hardRequired: false,
        display: true,
        customerType: customerTypes.INDIVIDUAL,
        taxIdTypeId: 0
    },
    name: 'TaxId'
});
